import React from 'react';
import { Navigate } from 'react-router-dom';
import { RoutingStep } from '../../../../../../../../../../models/Routes';
import listingInformationRouterRoutes from './subrouters/ListingInformation/routes';
import workflowConfigurationRouterRoutes from './subrouters/WorkflowConfiguration/routes';
import ListingInformation from './subrouters/ListingInformation';
import Gallery from './pages/PortfolioGallery';
import Leads from './pages/PortfolioLeads';
import WorkflowConfiguration from './subrouters/WorkflowConfiguration';
import Settings from './pages/Settings';
import Deal from './pages/Deal';
import {
  MessageSellerWrapper,
  messagingRoutes,
} from '../../../../../Messaging';
import QualificationQuestions from './pages/QualificationQuestions';

export default [
  {
    path: 'gallery',
    element: Gallery,
    labelId: 'gallery',
    stepName: 'gallery',
  },
  {
    path: 'deal',
    element: Deal,
    labelId: 'deal',
    stepName: 'deal',
  },
  {
    path: 'leads',
    element: Leads,
    labelId: 'leads',
    stepName: 'leads',
  },
  {
    path: 'messaging',
    routes: messagingRoutes,
    element: MessageSellerWrapper,
  },
  {
    path: 'listing-information',
    element: ListingInformation,
    labelId: 'listingInformation',
    stepName: 'listingInformation',
    routes: listingInformationRouterRoutes,
  },
  {
    path: 'qualification-questions',
    element: QualificationQuestions,
    labelId: 'qualification-questions',
    stepName: 'qualification-questions',
  },
  {
    path: 'workflow-configuration',
    element: WorkflowConfiguration,
    labelId: 'workflowConfiguration',
    stepName: 'workflowConfiguration',
    routes: workflowConfigurationRouterRoutes,
  },
  {
    path: 'settings/*',
    element: Settings,
    labelId: 'settings',
    stepName: 'settings',
    routes: workflowConfigurationRouterRoutes,
  },
  { index: true, element: <Navigate to="deal" replace /> },
] as Array<RoutingStep>;
